import './App.css';
import Logo from './Logo';
import { Button, createTheme, MuiThemeProvider } from '@material-ui/core';

function App() {

  const theme = createTheme({
    palette: {
      secondary: {
        main: '#ffffff'
      }
    }
  });

  console.error("You meant to check out our current openings: https://jobs.ashbyhq.com/Breadboard")


  return (
    <MuiThemeProvider theme={theme}>

      <div className="App">
        <div>
          <div style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            height: "500px",
            width: "500px",
            transform: "translate(-50%, -50%)",
            top: "50%",
            left: "50%",
          }}>

              <Logo />

  
            <h1 style={{ fontFamily: "monospace" }}>Breadboard Engineering</h1>
            <Button color="secondary" variant="outlined" onClick={() => window.open("https://jobs.ashbyhq.com/Breadboard", "_blank")}>View Current Openings</Button>
          </div>
        </div>
      </div>
    </MuiThemeProvider>
  );
}

export default App;
